<template>
<div><Topnav/>
  <div class="content">
    <div class="jumbotron text-center">
      <h2>Tutorials</h2>
      <hr class="bg-dark"/>
      <p>Learning Bot Creator is quick and easy, here are some of the tutorials.</p>
      
    </div>

    <div class="container">
      <div class="row">
        <div class="col-sm-4" v-for="(item,index) in tutorials" :key="index">
          <div class="card mb-3" style="min-height:230px;">
            <div class="card-header text-center bg-dark">
              <h4 class="text-white">{{item.name}}</h4>
            </div>
            <div class="card-body text-center">
              <p class="card-text">{{ item.shortDescription }}</p>

              <button type="link" name="button" class="btn btn-secondary" @click="toTutorial(item.path)">Read</button>
              <button type="link" name="button" class="btn btn-secondary" @click="toChat(item.link)">Demo</button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




  </div>
</template>


<script type="text/javascript">
import Topnav from "@/components/Topnav.vue";

  export default {
    name: "Tutorials",
    components:{
      Topnav
    },
    data: function() {
      return {
        tutorials: [{
            name: "Covid19 Tracker",
            shortDescription: "A bot from which you can quickly glance at the covid19 stats country wise.",
            link: "https://t.me/covid19trackerworldbot",
            path: "covid19Tracker"
          },
          {
            name: "Dogs Forever",
            shortDescription: "Gets you umlimited cute and adorable dog pictures. Explains how to create image slider.",
            link: "https://t.me/dogsforeverbot",
            path: "dogsForever"

          },
          {
            name: "Shopping Bot",
            shortDescription: "Helps in taking orders from customers.",
            link: "",
            path: "shoppingBot"
          }
        ]
      }
    },
    methods: {
      toTutorial: function(path) {
        this.$router.push({
          path: '/tutorials/' + path
        })
      },
      toChat: function(link) {
        window.open(link, '_blank')
      },

    }
  }
</script>
